import React, { Component } from 'react'
import JqxGrid from '../../widgets/jqwidgets-react/react_jqxgrid';
import JqxMenu from '../../widgets/jqwidgets-react/react_jqxmenu';
import io from '../../utils/socket-client';
import {createGridResizer} from '../../utils/Sizer';
import locale from '../../GridLocale';

export default class AccessGrid extends Component {

    constructor(props){
        super(props);
        this.source = {
            localdata: props.access,
            datatype: 'array',
            datafields: [
                { name: 'userLogin', type: 'string' },
                { name: 'userName', type: 'string' },
                { name: 'groupNames', type: 'array' },
                { name: 'promoterLogin', type: 'string' },
                { name: 'promoterName', type: 'string' },
                { name: 'startDate', type: 'date' },
                { name: 'endDate', type: 'date'}
            ]
        };
        this.dataAdapter = new window.$.jqx.dataAdapter(this.source);
        this.gridWidth = 1170;
    }

    componentWillReceiveProps(nextProps){
        console.log('accessGrid update');
        this.source.localdata = nextProps.access;
    }

    shouldComponentUpdate(nextProps, nextState){
        return false;
    }

    removeAccess(){
        let currentRow = this.currentSelectedRow;
        let rowid = this.refs.grid.getrowid(currentRow);
        let id = {
            userLogin: this.source.localdata[currentRow].userLogin,
            promoterLogin: this.source.localdata[currentRow].promoterLogin,
        };
        if(this.source.localdata[currentRow].startDate){
            id.startDate = this.source.localdata[currentRow].startDate;
        }
        if(this.source.localdata[currentRow].endDate){
            id.endDate = this.source.localdata[currentRow].endDate;
        }
        io.sendChange({
            uri:io.ACCESS_URI,
            operation: io.OPERATION_REMOVE,
            id: id,
            success: () => {
                this.refs.grid.deleterow(rowid);
            }
        });
    }

    componentDidMount(){
        this.refs.grid.localizestrings(locale);
        createGridResizer(this, this.gridWidth); //плюс боковая панель
        // window.$(window).resize(resizer);
        this.refs.grid.on('cellselect', (event) => {
            this.currentSelectedRow = event.args.rowindex;
        });
        this.refs.grid.on('cellunselect', () => {
            this.currentSelectedRow = null;
        });
        this.refs.grid.on('contextmenu', () => {
            return false;
        });
        this.refs.grid.on('rowclick', (event) => {
            this.currentSelectedRow = event.args.rowindex;
            if (event.args.rightclick) {
                this.refs.grid.selectrow(event.args.rowindex);
                let scrollTop = window.$(window).scrollTop();
                let scrollLeft = window.$(window).scrollLeft();
                let xCoords = (window.$(window).innerWidth() - parseInt(event.args.originalEvent.clientX, 10) > 100)
                    ? parseInt(event.args.originalEvent.clientX, 10) + 5 + scrollLeft
                    : parseInt(event.args.originalEvent.clientX, 10) - 95 + scrollLeft;
                let yCoords = (window.$(window).innerHeight() - parseInt(event.args.originalEvent.clientY, 10) > 87)
                    ? parseInt(event.args.originalEvent.clientY, 10) + 5 + scrollTop
                    : parseInt(event.args.originalEvent.clientY, 10) - 82 + scrollTop;
                this.refs.contextMenu.open(xCoords, yCoords);
                return false;
            }
        });

        this.refs.contextMenu.on('itemclick', (event) => {
            let args = event.args;
            this.refs.contextMenu.close();
            switch(window.$.trim(window.$(args).text())){
                case 'Добавить':
                    this.props.openNewAccessModal();
                    break;
                case 'Удалить':
                    setTimeout(() => {
                        if(window.confirm('Удалить?')) this.removeAccess();
                    }, 150);

                    break;
                default:
                    break;
            }
        });
    }

    render() {
        let self = this;
        let columns = [
            { text: 'Заказчик', datafield: 'userLogin', width: 150, editable: false },
            { text: 'Имя', datafield: 'userName', width: 150, editable: false},
            { text: 'Расклейщик', datafield: 'promoterLogin', width: 150, editable: false },
            { text: 'Имя', datafield: 'promoterName', width: 150, editable: false},
            {text: 'Группы', datafield: 'groupNames', width: 250, editable: false},
            { text: 'Начало', datafield: 'startDate', width: 150, columntype: 'datetimeinput', cellsformat: 'dd.MM.yyyy',
                cellvaluechanging: function(row, column, columntype, oldvalue, newvalue) {
                    if(!newvalue) return;
                    newvalue.setHours(0);
                    newvalue.setMinutes(0);
                    newvalue.setSeconds(0);
                    newvalue.setMilliseconds(0);
                    if (!oldvalue || oldvalue.getTime() !== newvalue.getTime()) {
                        let changedObj = self.source.localdata[row];
                        let rowid = self.refs.grid.getrowid(row);
                        let updatedRowData = self.source.localdata[row];
                        if(changedObj.endDate){
                            let endDate = changedObj.endDate;
                            if(!(changedObj.endDate instanceof Date)){
                                endDate = new Date(endDate);
                            }
                            if(endDate < newvalue){
                                self.props.setError('Дата конца не может быть раньше даты начала!');
                                return oldvalue;
                            }
                        }
                        let id = {
                            userLogin: changedObj.userLogin,
                            promoterLogin: changedObj.promoterLogin,
                        };
                        if(changedObj.startDate){
                            id.startDate = changedObj.startDate;
                        }
                        if(changedObj.endDate){
                            id.endDate = changedObj.endDate;
                        }
                        io.sendChange({
                            uri:io.ACCESS_URI,
                            operation: io.OPERATION_MODIFY,
                            data: {startDate: newvalue},
                            id: id,
                            fail: () => {
                                updatedRowData.startDate = oldvalue;
                                self.refs.grid.updaterow(rowid, updatedRowData);
                            },
                            success: () => {
                                self.source.localdata[row].startDate = newvalue;
                            }
                        });
                    }
                }
            },
            { text: 'Конец', datafield: 'endDate', width: 150, columntype: 'datetimeinput', cellsformat: 'dd.MM.yyyy',
                cellvaluechanging: function(row, column, columntype, oldvalue, newvalue) {
                    if(!newvalue) return;
                    newvalue.setHours(23);
                    newvalue.setMinutes(59);
                    newvalue.setSeconds(59);
                    newvalue.setMilliseconds(999);
                    if (!oldvalue || oldvalue.getTime() !== newvalue.getTime()) {
                        let rowid = self.refs.grid.getrowid(row);
                        let changedObj = self.source.localdata[row];
                        let updatedRowData = self.source.localdata[row];
                        if(changedObj.startDate){
                            let startDate = changedObj.startDate;
                            if(!(changedObj.startDate instanceof Date)){
                                startDate = new Date(startDate);
                            }
                            if(startDate > newvalue){
                                self.props.setError('Дата конца не может быть раньше даты начала!');
                                console.log('oldvalue', oldvalue);
                                if(oldvalue === null) return '';
                                return oldvalue;
                            }
                        }
                        let id = {
                            userLogin: changedObj.userLogin,
                            promoterLogin: changedObj.promoterLogin,
                        };
                        if(changedObj.startDate){
                            id.startDate = changedObj.startDate;
                        }
                        if(changedObj.endDate){
                            id.endDate = changedObj.endDate;
                        }
                        io.sendChange({
                            uri:io.ACCESS_URI,
                            operation: io.OPERATION_MODIFY,
                            data: {endDate: newvalue},
                            id: id,
                            fail: () => {
                                updatedRowData.endDate = oldvalue;
                                self.refs.grid.updaterow(rowid, updatedRowData);
                                self.props.setError('Не удалось изменить конечную дату!');
                            },
                            success: () => {
                                self.source.localdata[row].endDate = newvalue;
                            }
                        });
                    }
                }
            }
        ];
        return (
                <div ref={'container'} style={{display: 'flex', height: '100%', justifyContent: 'center', marginTop: 5, zIndex: -1, overflow: 'hidden'}}>
                    <JqxGrid
                        id={'grid'}
                        ref={'grid'}
                        height={window.$(window).innerHeight() - 45}
                        width={this.gridWidth}
                        editable={true}
                        enabletooltips={true}
                        pagesize={100}
                        pagesizeoptions={['25', '50', '100']}
                        pageable={this.props.access.length >= 300}
                        columnsresize={true}
                        filterable={true}
                        showfilterrow={true}
                        source={this.dataAdapter}
                        columns={columns}
                        selectionmode={'singlecell'}/>
                    <JqxMenu ref='contextMenu'
                             width={100} height={87} mode={'popup'} autoOpenPopup={false}>
                        <ul>
                            <li>Добавить</li>
                            <li>Удалить</li>
                            <li>Закрыть</li>
                        </ul>
                    </JqxMenu>
                </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/grids/AccessGrid.js